import { useState } from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

function CopyableRequestId({ requestId }: { requestId: string }) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    navigator.clipboard.writeText(requestId).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="flex items-center gap-1.5 mt-1.5" data-testid="toast-request-id">
      <span className="text-xs text-muted-foreground/70 font-mono leading-none">
        Ref: {requestId}
      </span>
      <button
        type="button"
        onClick={handleCopy}
        className="text-xs text-muted-foreground/70 hover:text-muted-foreground underline leading-none"
        data-testid="button-copy-request-id"
        title="Copy error reference"
      >
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  )
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, requestId, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
              {requestId && <CopyableRequestId requestId={requestId} />}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
